function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 419 280"
}, props), React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M38 66.818A8.818 8.818 0 0146.818 58h383.364A8.818 8.818 0 01439 66.818v177.364a8.818 8.818 0 01-8.818 8.818H46.818A8.818 8.818 0 0138 244.182V66.818z",
  fill: "#fff"
})), React.createElement("rect", {
  width: "294",
  height: "17",
  rx: "4.409",
  transform: "matrix(1 0 0 -1 135 125)",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  x: "135",
  y: "86.218",
  width: "65.254",
  height: "13.227",
  rx: "4.409",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  x: "135",
  y: "145",
  width: "294",
  height: "88",
  rx: "4.409",
  fill: "#F2F2F2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.667 80C71.947 80 60 91.947 60 106.667c0 14.72 11.947 26.666 26.667 26.666 14.72 0 26.666-11.946 26.666-26.666S101.387 80 86.667 80zm0 8c4.426 0 8 3.573 8 8s-3.574 8-8 8a7.99 7.99 0 01-8-8c0-4.427 3.573-8 8-8zm-16 29.28c3.44 5.173 9.333 8.587 16 8.587 6.666 0 12.56-3.414 16-8.587-.08-5.307-10.694-8.213-16-8.213-5.334 0-15.92 2.906-16 8.213z",
  fill: "#2655BD"
}), React.createElement("g", {
  filter: "url(#filter1_d)"
}, React.createElement("path", {
  d: "M12-153.182A8.818 8.818 0 0120.818-162h319.364a8.818 8.818 0 018.818 8.818V28.182A8.818 8.818 0 01340.182 37H20.818A8.818 8.818 0 0112 28.182v-181.364z",
  fill: "#fff",
  fillOpacity: ".7"
}))), React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: "33.591",
  y: "55.795",
  width: "409.818",
  height: "203.818",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "2.205"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "2.205"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d",
  x: "7.591",
  y: "-164.205",
  width: "345.818",
  height: "207.818",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "2.205"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "2.205"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h419v280H0z"
})))));